module.exports = __webpack_public_path__ + "media/music/bells_2-de1d41f9.mp3";